// BlogDetail.js

import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Aos from "aos";
import { IoMdShare } from "react-icons/io";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { server } from "../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Modal } from "react-bootstrap";
import { useSelectAccess } from "../../store/stateFunctions";
import { Button } from "@mui/material";
import Textarea from "@mui/joy/Textarea";
import { shareurl } from "../../config";
import ShareModal from "../../ShareModal";

const AdminBlogDetails = () => {
  document.title = "Blogs";
  const user = useSelectAccess("Student");
  const [loading, setLoading] = useState(true);

  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedRating, setSelectedRating] = useState(0);
  const [showShareModal, setShowShareModal] = useState(false);
  const [sharedUrl, setSharedUrl] = useState("");
  const [sharedTitle, setSharedTitle] = useState("");
  const isLoggedIn = user && user;
  const navigate = useNavigate();

  useEffect(() => {
    getyuvablogs();
    if (selectedRating !== 0) {
      submitRating();
    }
  }, [id, selectedRating]);

  // Function to open the Share modal
  const openShareModal = (url, title) => {
    setSharedUrl(shareurl);
    setSharedTitle(title);
    setShowShareModal(true);
  };

  // Function to close the Share modal
  const closeShareModal = () => {
    setShowShareModal(false);
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Open modal for confirmation
  const handleOpenModal = () => {
    if (isLoggedIn) {
      setShowModal(true);
    } else {
      toast.info("Please log in to Add Your Comment");
      navigate("/loginstudent");
    }
  };

  const initialValues = {
    comment: "",
  };

  const { values, handleChange, handleSubmit, resetForm } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      comment: Yup.string().required("Please Enter comment"),
    }),

    onSubmit: (values, action) => {
      console.log(values);
      server
        .post(`/blog/giveadmrating/${id}`, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("Comment shared");
              handleCloseModal();
              resetForm();
            }
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else {
            toast.error(error.response.data.error);
          }
        });
    },
  });

  const submitRating = () => {
    server
      .post(
        `/blog/giveadmrating/${id}`,
        {
          star: selectedRating,
        },
        {
          headers: {
            Authorization: user.authToken,
          },
        }
      )
      .then(function (response) {
        console.log("Rating submitted successfully:", response.data.message);
        toast.success("Rating Addded");
      })
      .catch(function (error) {
        console.error("Error submitting rating", error);
        toast.error(error.message);
      });
  };

  // yuva blogs
  const getyuvablogs = () => {
    server
      .get(`/blog/getblogs/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setBlog(response.data);
        }
      })
      .catch(function (error) {});
  };

  if (!blog) {
    return (
      <div>
        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className="container col-md-8 shadow-sm p-3"
      style={{ marginTop: "1rem" }}
    >
      <div className="row">
        <div className="col-md-8">
          <h3>{blog.title}</h3>
          <p>Posted On : {blog.date}</p>
        </div>
        <div className="col-md-4 text-end">
          <p className="text-end fs-3">
            <IoMdShare onClick={() => openShareModal(blog.title)} />
          </p>
        </div>
      </div>
      <img
        data-aos="fade-right"
        className="img-fluid"
        src={blog.image}
        alt=""
      />
      <p
        style={{ textAlign: "justify" }}
        className="mt-2"
        data-aos="fade-left "
      >
        {blog.description}
      </p>
      <p>
        <b>Posted By : </b>
        {blog.posted_by}
      </p>
      <p>
        <b>Category : </b>
        {blog.category}
      </p>
      <p>
        <b>Posted Date : </b> {blog.Date}
      </p>
      <p>
        <b>Written By : </b> {blog.written_by}
      </p>
      <p>
        {isLoggedIn ? (
          <>
            {[1, 2, 3, 4, 5].map((index) => (
              <AiFillStar
                key={index}
                className={`fs-3 ${
                  index <= selectedRating ? "text-warning" : "text-muted"
                }`}
                onClick={() => setSelectedRating(index)}
              />
            ))}
          </>
        ) : (
          <p>
            Please <NavLink to="/loginstudent">login</NavLink> to add ratings
            and comments.
          </p>
        )}
      </p>
      <div className="total-reviews">
        <b className="average-rating my-2 badge bg-success">
          {blog.average_rating} <AiFillStar />
        </b>
        &nbsp;{blog.total_ratings} Reviews
      </div>{" "}
      <p>
        <div>
          <button
            className="banner text-white p-1 border-0 rounded-3"
            onClick={() => handleOpenModal()}
          >
            Add Comment
          </button>
        </div>
      </p>
      <p>
        <b>Comments : </b>
        {blog?.student_ratings?.map((item) => {
          return (
            <>
              {item.comment && (
                <p>
                  {item.name}
                  <b className="average-rating my-2 badge bg-success ms-2">
                    {item.star} <AiFillStar />
                  </b>
                  <p>{item.comment}</p>
                </p>
              )}
            </>
          );
        })}
      </p>
      {/* <p>
        <b>Ratings : </b>
        <AiOutlineStar />
        <AiOutlineStar />
        <AiOutlineStar />
        <AiOutlineStar />
      </p> */}
      {/* Modal for confirmation */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Please Share Your Comment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <Textarea
              minRows={4}
              name="comment"
              className="my-3"
              value={values.comment}
              onChange={handleChange}
              placeholder="Please Share Your Good Feedback For This Shop..."
            />
            <Modal.Footer>
              <Button variant="contained" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="success"
                className="ms-2"
              >
                Share
              </Button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>
      <ShareModal
        showModal={showShareModal}
        handleClose={closeShareModal}
        url={`https://yuvasarathi.com/#/adminblogs/${id}`}
        title={sharedTitle}
      />
    </div>
  );
};

export default AdminBlogDetails;
